// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"az_Q9","azLogo":"az_R9","azLogoMedium":"az_S9"};